<template>
    <div>
        <div class="list-view__panel">
            <span v-if="useCustomDropdown">
                <vue-accessible-select v-model="year" :options="years">
                    <template v-slot:label>
                        <strong v-html="dropdownLabel"></strong>
                    </template>
                    <template v-slot:arrow>
                        <svg width="28"
                             height="16"
                             viewBox="0 0 28 16"
                             fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path d="M26.9233 1.92334L14.0003 13.9233L1.07719 1.92334"
                                  stroke="white"
                                  stroke-width="3" />
                        </svg>
                    </template>
                </vue-accessible-select>
            </span>
            <div v-else>
                <label for="year-dropdown">{{ dropdownLabel }}</label>
                <select v-model="year" id="year-dropdown">
                    <option v-for="year in years" v-bind:value="year.value">{{ year.label }}</option>
                </select>
            </div>
        </div>

        <div v-if="loading">Loading list...</div>
        <div v-if="!loading && (items === undefined || items.length === 0)">Der er ingen sider i listen...</div>
        <ul class="list-view__items" v-if="!loading && items !== undefined">
            <li v-for="item in items">
                <a v-bind:href="item.url" v-on:click="TestClick(event)" class="list-item">
                    <span class="list-item__date">{{ item.date }}</span>
                    <p class="list-item__title">
                        {{ item.title }}
                    </p>
                    <p class="list-item__test"
                       v-if="item.manchet !== undefined && item.manchet !== ''">
                        {{ item.manchet }}
                    </p>
                    <span class="list-item__arrow"
                          :class="theme"></span>
                </a>
            </li>
        </ul>

        <ol class="list-view__pagination" v-if="!loading && totalPages > 1"
            :class="theme">
            <template>
                <li v-bind:class="{ 'inactive': currentPage == 1 }"
                    v-on:click="ChangePage(currentPage - 1)">
                    <
                </li>
            </template>
            <template v-if="totalPages < 11">
                <li v-for="page in totalPages"
                    v-bind:class="{ 'is-active': page == currentPage }"
                    v-on:click="ChangePage(page)">
                    {{ page }}
                </li>
            </template>
            <template v-else>
                <template v-if="(currentPage < 5) || (currentPage > totalPages - 4)">
                    <li v-for="page in 5"
                        v-bind:class="{ 'is-active': page == currentPage }"
                        v-on:click="ChangePage(page)">
                        {{ page }}
                    </li>
                    <li class="inactive">...</li>
                    <li v-bind:class="{ 'is-active': (totalPages - 4) == currentPage }"
                        v-on:click="ChangePage(totalPages - 4)">
                        {{ totalPages - 4 }}
                    </li>
                    <li v-bind:class="{ 'is-active': (totalPages - 3) == currentPage }"
                        v-on:click="ChangePage(totalPages - 3)">
                        {{ totalPages - 3 }}
                    </li>
                    <li v-bind:class="{ 'is-active': (totalPages - 2) == currentPage }"
                        v-on:click="ChangePage(totalPages - 2)">
                        {{ totalPages - 2 }}
                    </li>
                    <li v-bind:class="{ 'is-active': (totalPages - 1) == currentPage }"
                        v-on:click="ChangePage(totalPages - 1)">
                        {{ totalPages - 1 }}
                    </li>
                    <li v-bind:class="{ 'is-active': totalPages == currentPage }"
                        v-on:click="ChangePage(totalPages)">
                        {{ totalPages }}
                    </li>
                </template>
                <template v-else>
                    <li v-on:click="ChangePage(1)">1</li>
                    <li class="inactive">...</li>
                    <li v-on:click="ChangePage(currentPage - 2)">
                        {{ currentPage - 2 }}
                    </li>
                    <li v-on:click="ChangePage(currentPage - 1)">
                        {{ currentPage - 1 }}
                    </li>
                    <li v-bind:class="{ 'is-active': currentPage == currentPage }"
                        v-on:click="ChangePage(currentPage)">
                        {{ currentPage }}
                    </li>
                    <li v-on:click="ChangePage(currentPage + 1)">
                        {{ currentPage + 1 }}
                    </li>
                    <li v-on:click="ChangePage(currentPage + 2)">
                        {{ currentPage + 2 }}
                    </li>
                    <li class="inactive">...</li>
                    <li v-on:click="ChangePage(totalPages)">{{ totalPages }}</li>
                </template>
            </template>            
            <template>
                <li v-bind:class="{ 'inactive': currentPage == totalPages }"
                    v-on:click="ChangePage(currentPage + 1)">
                    >
                </li>
            </template>

        </ol>
    </div>
</template>

<script>
    import axios from "axios";
    import { VueAccessibleSelect } from "vue-accessible-select";

    /* IE POLYFILLS */
    import 'es6-promise/auto';

    var pageIdentifer = 'page=';
    var yearIdentifer = 'year=';

    export default {
        name: "ListViewComponent",
        components: {
            VueAccessibleSelect,
        },
        props: ["apiUrl", "nodeId", "startYear", "websiteType"],
        data() {
            return {
                error: false,
                loading: true,
                year: -1,
                years: [
                    {
                        value: 0,
                        label: "Alle",
                    },
                ],
                currentPage: 1,
                totalPages: 0,
                items: undefined,
                dropdownLabel: "Vælg år",
                useCustomDropdown: Array.prototype.fill != undefined
            };
        },
        computed: {
            theme() {
              return {
                'theme-blue': this.websiteType === 'Advokatnaevnet',
                '': this.websiteType === 'Advokatsamfundet'
              };
            },
        },
        methods: {
            GetList() {
                axios
                    .get(this.apiUrl, {
                        params: {
                            nodeId: this.nodeId,
                            selectedYear: this.year,
                            page: this.currentPage,
                        },
                    })
                    .then((response) => {
                        this.totalPages = response.data.totalPages;
                        this.items = response.data.items;
                        this.loading = false;
                        this.UpdateUrl();
                    })
                    .catch((er) => {
                        this.error = true;
                    })
                    .then(function () { });
            },
            ChangePage(page) {
                if (page > 0 && (page <= this.totalPages || this.totalPages === 0)) {
                    this.currentPage = page;
                    this.GetList();
                }
            },
            SetYears() {
                var currentYear = new Date().getFullYear();
                for (var i = currentYear; i >= this.startYear; i--) {
                    this.years.push({ value: i, label: i.toString() });
                }
            },
            UpdateUrl() {
                var newUrl = window.location.pathname;
                if (this.totalPages > 0 && this.currentPage > 1) {
                    newUrl += "?" + pageIdentifer + this.currentPage;
                    if (this.year > 0) {
                        newUrl += "&" + yearIdentifer + this.year;
                    }
                } else if (this.year > 0) {
                    newUrl += "?" + yearIdentifer + this.year;
                }
                window.history.replaceState(window.location.pathname, document.title, newUrl);
                localStorage.setItem('goBackLinkUrl', newUrl);
            },
            SetInitValues() {
                var search = window.location.search;
                var pageIndex = search.indexOf(pageIdentifer);
                var yearIndex = search.indexOf(yearIdentifer);
                var substr;
                if (pageIndex > -1) {
                    substr = search.substr(pageIndex + pageIdentifer.length, search.length - pageIndex);
                    var endIndex = substr.indexOf('&');
                    if (endIndex > -1) {
                        substr = substr.substr(0, endIndex);
                    }
                    this.currentPage = parseInt(substr);
                }
                if (yearIndex > -1) {
                    substr = search.substr(yearIndex + yearIdentifer.length, search.length - yearIndex);
                    var endIndex = substr.indexOf('&');
                    if (endIndex > -1) {
                        substr = substr.substr(0, endIndex);
                    }
                    this.year = parseInt(substr);
                } else {
                    this.year = 0;
                }
            }
        },
        mounted() {
            this.SetYears();
            this.SetInitValues();
        },
        watch: {
            year: function (newYear, oldYear) {
                this.ChangePage(oldYear > -1 ? 1 : this.currentPage);
            },
        },
    };
</script>

<style>
    @import "~vue-accessible-select/src/styles/core.scss";
    @import "vue-accessible-select/src/styles/themes/default.scss";

    .theme-blue .v-select__option--selected, 
    .theme-blue .v-select__option:hover, 
    .theme-blue .v-select__option:focus {
        color: #005989;
    }
    .theme-petroleum .v-select__option--selected, 
    .theme-petroleum .v-select__option:hover, 
    .theme-petroleum .v-select__option:focus {
        color: #4E7E85;
    }

    .theme-green .v-select__option--selected,
    .theme-green .v-select__option:hover,
    .theme-green .v-select__option:focus {
        color: #263E30;
    }

    .theme-blue .v-select__btn {
        background-color: #005989;
    }

    .theme-petroleum .v-select__btn {
        background-color: #4E7E85;
    }

    .theme-green .v-select__btn {
        background-color: #263E30;
    }

    .v-select {
        width: 270px;
    }

    .v-select__btn {
        background-color: #a70059;
        color: #fff;
        cursor: pointer;
        height: 60px;
        border-radius: 0;
        border: 0;
        padding: 0 25px;
    }

    

    .v-select__arrow svg {
        width: 20px;
        height: 20px;
    }

    .v-select__menu {
        border-radius: 0;
        padding: 0;
        border: 0;
        box-shadow: 0 4px 10px rgba(#2c0313, 0.1);
        z-index:100;
    }

    .v-select__list {
        max-height: none;
    }

    .v-select__option {
        padding: 8px 25px;
    }

        .v-select__option:hover:not(.v-select__option--selected) {
            background-color: transparent;
        }

    .v-select__option--selected {
        background-color: transparent;
        color: #a70059;
    }

    .v-select__option:hover,
    .v-select__option:focus {
        color: #a70059;
    }
</style>